'use client'

import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

export const ProductPrescriptionDialogLifestyle: FC<{
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose }) => {
  return (
    <Dialog onClose={onClose} open={isOpen}>
      <DialogTitle onClose={onClose}>
        <FormattedMessage id="lifestyle_product.modal.title" />
      </DialogTitle>
      <DialogContent className="flex flex-col">
        <FormattedMessage id="lifestyle_product.modal.text" />
      </DialogContent>
    </Dialog>
  )
}
